import { ReactNode, useState } from 'react';
import classNames from 'classnames';
import Typography from 'components/atoms/Typography';

interface ToggleControlledProps {
  isChecked: boolean;
  onChange: (b: boolean) => any;
  disabled?: boolean;
  label?: ReactNode;
  required?: boolean;
}

export function ToggleControlled({ isChecked, onChange, disabled, label, required }: ToggleControlledProps) {
  const content = (
    <div
      onClick={
        disabled
          ? undefined
          : (e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(!isChecked);
            }
      }
      className={classNames(
        'relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in',
        {
          'cursor-pointer': !disabled,
          'opacity-50': disabled,
        },
      )}
    >
      <div
        className={classNames(
          'absolute block w-5 h-5 rounded-full bg-white border-2 appearance-none transition duration-200 ease-in',
          {
            'right-0 border-black': isChecked,
            'border-glooMistyGray': !isChecked,
          },
        )}
      />
      <div
        className={classNames('toggle-label block overflow-hidden h-5 rounded-full transition duration-200 ease-in', {
          'bg-black': isChecked,
          'bg-glooMistyGray': !isChecked,
        })}
      />
    </div>
  );
  if (label) {
    return (
      <div className="inline-block relative w-full">
        {label && (
          <Typography variant="label" className="pb-2 pl-1">
            {label}
            {required && <span className="text-red text-xs">*</span>}
          </Typography>
        )}
        {content}
      </div>
    );
  }

  return content;
}

function Toggle({ defaultOn, onChange, disabled, label }: { defaultOn?: boolean } & Partial<ToggleControlledProps>) {
  const [isChecked, setIsChecked] = useState(defaultOn || false);

  const handleToggle = () => {
    if (disabled) return;
    onChange(!isChecked);
    setIsChecked(!isChecked);
  };

  return <ToggleControlled isChecked={isChecked} onChange={handleToggle} disabled={disabled} label={label} />;
}

export default Toggle;
